import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('SpecialOfferContainer')(
  css({
    border: '1px solid #ccc',
    marginTop: 'l',
    marginBottom: 'l',
    maxWidth: '930px',
    borderRadius: '3px',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.25)',
    position: 'relative',
    minHeight: ['unset', 'unset', '612px'],
    display: 'flex',
    flexDirection: 'column',
    gap: 'xs',
  }),
);

themeStyles.addBaseStyles('LoadingContainer')(
  css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // 612px is the min height for the special offers container on desktop
    // 90vh for tablet and mobile from design as a guess
    minHeight: ['90vh', '90vh', '612px'],
  }),
);

themeStyles.addBaseStyles('MainContentContainer')(
  css({
    paddingY: 'm',
    paddingX: ['m', 'm', 'xl'],
  }),
);

themeStyles.addBaseStyles('ModelContainer')(
  css({
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    alignItems: ['center', 'center', 'unset'],
    justifyContent: 'space-between',
    gap: '20px',
    height: '100%',
  }),
);

themeStyles.addBaseStyles('ModelDetailsContainer')(
  css({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    maxWidth: ['100%', '100%', '191px'],
    flexWrap: 'wrap',
  }),
);

themeStyles.addBaseStyles('ModelInfoContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: 's',
    paddingTop: '10px',
    alignItems: ['center', 'center', 'unset'],
  }),
);

themeStyles.addBaseStyles('ActionContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'm',
  }),
);

themeStyles.addBaseStyles('ModelImageWrapper')(
  css({
    width: '108px',
  }),
);

themeStyles.addBaseStyles('ModelImageContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'xs',
    flexGrow: '1',
  }),
);

themeStyles.addBaseStyles('PricingAndImageContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'xs',
    flexGrow: '1',
  }),
);

themeStyles.addBaseStyles('SellingPriceContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'xs',
    paddingTop: ['m', 'm', 'unset'],
    margin: ['0 auto', '0 auto', 'unset'],
  }),
);

themeStyles.addBaseStyles('SellingPriceCopy')(
  css({
    wordBreak: 'break-word',
  }),
);

themeStyles.addBaseStyles('PriceWrapper')(
  css({
    display: 'flex',
    gap: 'xs',
    justifyContent: ['center', 'center', 'flex-start'],
  }),
);

themeStyles.addBaseStyles('Price')(
  css({
    fontSize: ['24px', '24px', '34px'],
  }),
);

themeStyles.addBaseStyles('CTAContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: 's',
    width: '100%',
    paddingTop: ['m', 'm', 'unset'],
  }),
);

themeStyles.addBaseStyles('StyledExploreLink')(
  css({
    paddingTop: ['m', 'm', 'unset'],
    wordBreak: 'break-word',
  }),
);

themeStyles.addBaseStyles('BtnWrapper')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'xs',
  }),
);

themeStyles.addBaseStyles('AccordionTitle')(
  css({
    flexGrow: '1',
    textAlign: 'center',
    textDecoration: 'underline',
  }),
);

themeStyles.addBaseStyles('AccordionBodyWrapper')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: 's',
    padding: '30px 24px 24px 24px',
  }),
);

themeStyles.addBaseStyles('StyledLoyaltyBadge')(
  css({
    position: 'absolute',
    top: '-15px',
  }),
);

themeStyles.addBaseStyles('StyledButton')(
  css({
    width: ['100%', '100%', '191px'],
    minWidth: 'auto',
    height: 'auto',
    wordBreak: 'break-word',
  }),
);

themeStyles.addBaseStyles('OfferCardContainerWrapper')(
  css({
    maxWidth: '930px',
    margin: 'l',
    marginLeft: ['l', 'l', 'auto'],
    marginRight: ['l', 'l', 'auto'],
  }),
);

themeStyles.addBaseStyles('StyledTooltip')(
  css({
    display: 'inline-flex',
    ml: '4px',
  }),
);

themeStyles.addBaseStyles('LoadMoreButtonContainer')(
  css({
    display: 'flex',
    paddingTop: 'xxs',
  }),
);

themeStyles.addBaseStyles('LoadMoreButton')(
  css({
    margin: 'auto',
  }),
);

export default themeStyles;
